import "globals";

(function (window, document, $) {
    // initialize slick when node is created in the backend
    const handleNodeCreated = function (event) {
        const createdElement = event.detail.element;
        if (createdElement.classList.contains("teaser-slider--article") && $.prototype.slick) {
            $(createdElement).find(".slider__items").slick();
        }
    };

    document.addEventListener("Neos.NodeCreated", handleNodeCreated, false);
})(window, document, jQuery);
